import styled from 'styled-components'
import { Style } from '../../styles'

const TaskSection = styled.div`
	margin-bottom: ${Style.spacing.x3};
`

export default TaskSection